import type { NavItem } from '@/app/nav/collect'

/**
 * "CV database" and "Job offers" (Recruiting) are the legacy menu, declared once by the shell
 * (`src/modules/shell/nav.ts`, ids `re-cvs`, `re-job-offers`) and already pointing at this module's paths. Legacy had
 * no other entry (the onboarding nav does not link job offers, §3), so the module adds none.
 */
const nav: NavItem[] = []

export default nav
